import React from 'react';
import clsx from 'clsx';
import { Icons, Box, ChakraInput } from '@shared/ui';
import { useBuyerProductStore } from 'app/store/product';
import { useProductCount } from './useProductCount';
import STYLE from './ProductInfoGroup.module.scss';

export const ProductCartCounter: React.FC = () => {
    const { productQuantity, setProductQuantity, product, selectedProductDetailId } =
        useBuyerProductStore();

    const { outOfStock, ...productCountApi } = useProductCount({
        productQuantity,
        product,
        selectedProductDetailId,
        onChange: setProductQuantity,
    });

    return (
        <div className={STYLE.counterBox}>
            <Box
                as="button"
                role="button"
                className={STYLE.counterAction}
                {...productCountApi.dec}
            >
                <Icons.csr.Minus size="1.25em" weight="bold" />
            </Box>
            <Box className={STYLE.counterInputBox}>
                <ChakraInput
                    border="none"
                    htmlSize={productCountApi.input.value.toString().length || 1}
                    className={STYLE.counterInput}
                    {...productCountApi.input}
                />
            </Box>
            <Box
                as="button"
                role="button"
                className={clsx(STYLE.counterAction, outOfStock && STYLE.disabled)}
                {...productCountApi.inc}
            >
                <Icons.csr.Plus size="1.25em" weight="bold" />
            </Box>
        </div>
    );
};
